import * as React from "react";
import type { SVGProps } from "react";
const SvgPowerButton = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={20}
    fill="none"
    viewBox="0 0 21 20" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.464 5.285a6.667 6.667 0 1 1-9.428 0M10.75 3.332v6.667"
    />
  </svg>
);
export default SvgPowerButton;
